import { getUserState } from '@carvana/core-auth';
import { CoreEvent, eventNames } from '@carvana/core-events';
import { useEffect, useState } from 'react';

export default function useExperimentUserId(serverUserId: string) {
  const [clientUserId, setClientUserId] = useState('');

  useEffect(() => {
    function updateClientUserId() {
      setClientUserId(getUserState().user.user_id ?? '');
    }

    updateClientUserId();
    CoreEvent.on(eventNames.auth.change, updateClientUserId);

    return () => {
      CoreEvent.off(eventNames.auth.change, updateClientUserId);
    };
  }, []);

  return serverUserId || clientUserId;
}
